import * as React from "react";
import Svg, { Path } from "react-native-svg";

function ChangeMap(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <Path
        d="M5 18.431c0 .142.029.283.086.411.057.128.14.242.244.331l10.146 8.534c.16.14.36.216.566.216a.858.858 0 00.566-.216l10.146-8.696a.996.996 0 00.116-1.341.876.876 0 00-.604-.34.855.855 0 00-.653.217l-9.576 8.19-9.575-8.048a.842.842 0 00-.953-.128.913.913 0 00-.374.356A1 1 0 005 18.43z"
        fill="#000"
        fillOpacity={0.8}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.692 5.222a1 1 0 00-1.287.025l-9.108 7.97a1 1 0 00-.003 1.502l9.108 8.05a1 1 0 001.294.026l9.867-8.05a1 1 0 00-.004-1.553l-9.867-7.97zm8.176 8.744l-8.724-7.047-8.053 7.047 8.053 7.118 8.724-7.118z"
        fill="#000"
        fillOpacity={0.8}
      />
    </Svg>
  );
}

export default ChangeMap;
